import React from 'react';
import PropTypes from 'prop-types';
import {Cloud, Upload, FolderOpen, Trash2, Loader} from 'lucide-react';
import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';
import styles from './magblocks-modal.css';

const MagblocksLoadModal = ({view, projects, isLoading, deletingId, onCloudLoad, onImport, onSelect, onDelete, onBack, onCancel}) => (
    <Modal
        className={styles.modalContent}
        contentLabel="Load Project"
        id="magblocksLoad"
        onRequestClose={onCancel}
    >
        <Box className={styles.modalBody}>
            {view === 'options' && (
                <div className={styles.stackActions}>
                    <button
                        className={styles.btnPrimary}
                        onClick={onCloudLoad}
                    >
                        <Cloud size={16} strokeWidth={2.5} />
                        {'My Projects'}
                    </button>
                    <button
                        className={styles.btn}
                        onClick={onImport}
                    >
                        <Upload size={16} strokeWidth={2.5} />
                        {'Import from Device (.mgnm)'}
                    </button>
                </div>
            )}

            {view === 'projects' && (
                isLoading ? (
                    <ul className={styles.projectList}>
                        {[1, 2, 3, 4].map(i => (
                            <li key={i}>
                                <div className={styles.projectRow}>
                                    <div className={styles.projectInfo}>
                                        <div className={styles.skeletonName} />
                                        <div className={styles.skeletonDate} />
                                    </div>
                                    <div className={styles.projectActions}>
                                        <div className={styles.skeletonBtn} />
                                        <div className={styles.skeletonIcon} />
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : projects.length === 0 ? (
                    <p className={styles.body}>{'No saved projects yet.'}</p>
                ) : (
                    <ul className={styles.projectList}>
                        {projects.map(p => (
                            <li key={p.id}>
                                <div className={styles.projectRow}>
                                    <div className={styles.projectInfo}>
                                        <span className={styles.projectName}>{p.name}</span>
                                        <span className={styles.projectDate}>
                                            {new Date(p.updatedAt).toLocaleDateString()}
                                        </span>
                                    </div>
                                    <div className={styles.projectActions}>
                                        <button
                                            className={styles.loadBtn}
                                            disabled={!!deletingId}
                                            onClick={() => onSelect(p)}
                                        >
                                            <FolderOpen size={14} strokeWidth={2.5} />
                                            {'Load'}
                                        </button>
                                        <button
                                            className={styles.deleteBtn}
                                            disabled={!!deletingId}
                                            onClick={e => { e.stopPropagation(); onDelete(p); }}
                                        >
                                            {deletingId === p.id ? (
                                                <Loader className={styles.spinner} size={14} strokeWidth={2.5} />
                                            ) : (
                                                <Trash2 size={14} strokeWidth={2.5} />
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                )
            )}

            {view === 'projects' && (
                <div className={styles.actions}>
                    <button className={styles.btn} onClick={onBack}>{'Back'}</button>
                </div>
            )}
        </Box>
    </Modal>
);

MagblocksLoadModal.propTypes = {
    view: PropTypes.oneOf(['options', 'projects']).isRequired,
    projects: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        updatedAt: PropTypes.string
    })),
    isLoading: PropTypes.bool,
    deletingId: PropTypes.string,
    onCloudLoad: PropTypes.func,
    onImport: PropTypes.func,
    onSelect: PropTypes.func,
    onDelete: PropTypes.func,
    onBack: PropTypes.func,
    onCancel: PropTypes.func.isRequired
};

MagblocksLoadModal.defaultProps = {
    projects: [],
    isLoading: false,
    deletingId: null
};

export default MagblocksLoadModal;
